import $ from './jquery-shim.js';

var defaultOptions = {
  content: $('.c-forms-simple__content'),
  radioWrap: $('.c-forms-simple__radio'),
  selectMaker: $('.c-forms-simple__content').find('select[name="maker"]'),
  selectRepair: $('.c-forms-simple__content').find('select[name="repair"]'),
  submitButton: $('.c-forms-simple__submit').find('button'),
  result: $('.c-box-results__price').find('span'),
  resultsm: $('.c-box-results__price').find('small'),
  price: "",
  categoryValue: "",
  makerValue: "",
  defaultSelect: $('.c-forms-simple__content').find('select').html(),
};

export default class Simulator {

  constructor(options) {

    if ($('.c-box-results').length < 1 ) {
      return;
    }

    this.options = $.extend(defaultOptions, options);
    this.init();

    $.getJSON('/wp-content/themes/watchdoctor-wp/simulator-price.json', (data) => {
    // $.getJSON('/simulator-price.json', (data) => {
      this.initialized(data);
      this.radioChanged(data);
      this.writePrice();
    });
  }

  /**
   * 初期化
   */
  init() {
    // ターゲットが存在しない場合は実行しない
    if (!this.options.result) {
      return false;
    }

    $('.c-box-results__inner').hide();
    $('.c-box-results__read').hide();
  }

  /* 時計種別を全て表示する */
  initialized(data) {
    for (var dataList in  data) {
      this.options.radioWrap.append('<span><label><input type="radio" name="category" value="' + dataList + '"><span>' + data[dataList].category + '</span></label></span>')
    }
  }


  /* ラジオボタンを選択したとき実行する */
  radioChanged(data) {
    var self = this;
    var changeFlag = false;
    var radio = self.options.content.find('input[type="radio"]');
    radio.on('change', function () {
      self.init(data);
      // セレクトボックスを元の状態に戻す
      if (changeFlag == true) {
        self.options.selectMaker.html(self.options.defaultSelect);
        self.options.selectRepair.html(self.options.defaultSelect);
      }
      // 次のセレクトボックスの内容を出力
      for (var maker in data[this.value].data) {
        self.options.categoryValue = this.value;
        self.options.selectMaker.append('<option value="' + maker + '">' + data[this.value].data[maker].maker + '</option>');
      }

      changeFlag = true;

      self.selectChanged(data, self.options.categoryValue);
    });
  }

  /* セレクトボックスを選択したとき実行する */
  selectChanged(data, categoryValue) {
    var self = this;
    // var changeFlag = false;
    var prevValue = categoryValue;

    self.options.selectMaker.on('change', function () {
      // セレクトボックスを元の状態に戻す
      // if (changeFlag == true) {
      self.options.selectRepair.html(self.options.defaultSelect);
      // }

      // 次のセレクトボックスの内容を出力
      for (var repair in data[prevValue].data[this.value].data) {
        // 時計メーカーのvalueを保存
        self.options.makerValue = this.value;
        self.options.selectRepair.append('<option value="' + repair + '">' + data[prevValue].data[this.value].data[repair].repair + '</option>');
      }

      // changeFlag = true;
    });


    /* 料金を取得 */
    self.options.selectRepair.on('change', function () {
      self.options.price = data[prevValue].data[self.options.makerValue].data[this.value].price;
      $('.c-box-results__inner').show();
      $('.c-box-results__read').show();

      if (self.options.price) {
        if (Number(self.options.price).toLocaleString() == 0) {
          self.options.result.text('都度見積');
          self.options.resultsm.text('');
        } else {
          self.options.result.text('¥' + Number(self.options.price).toLocaleString());
          self.options.resultsm.text('（税抜）');
        }
      } else {
        return false;
      }
    });
  }


  writePrice() {
    var self = this;

    $(self.options.submitButton).on('click', (e) => {
      e.preventDefault();
      if (self.options.price) {
        if (Number(self.options.price).toLocaleString() == 0) {
          self.options.result.text('都度見積');
          self.options.resultsm.text('');
        } else {
          self.options.result.text('¥' + Number(self.options.price).toLocaleString());
          self.options.resultsm.text('（税抜）');
        }
      } else {
        return false;
      }
    });

  }
}
